export enum ProductGroupTabs {
  Content = 'Content',
  ActiveIngredients = 'Active Ingredients',
  MaHolder = 'MA Holder',
  ProductType = 'Product Type',
}
